import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from './token.service';
import { AlertServiceService } from './alert-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private ts: TokenService,
    private as: AlertServiceService
  ) { }

  login(data: any) {
    return this.http.post(`${environment.url}/auth/loginAdmin`, data, {headers: new HttpHeaders({partnerId: '100000', type : 'QTAdministration'})});
  }
  sendOtpForLogin(data: any) {
    return this.http.post(`${environment.url}/user/sendOtp`, data  );
  }
  vrifyOtpForLogin(data: any) {
    return this.http.post(`${environment.url}/user/verifyOtp`, data  );
  }

  isLoggedIn(): boolean {
    if (this.ts.getToken()) {
      return true;
    } else {
      return false;
    }
  }

  logout() {
    // localStorage.clear();
    localStorage.removeItem('admin');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('token');
    this.router.navigate(['/auth/login']);
    this.as.successToast('logout Successfully');
  }


  sendOtp(data:any) {
    return this.http.post(`${environment.url}/auth/forgetSAPassword`, data);
  }

  verifyOtp(data:any) {
    return this.http.post(`${environment.url}/auth/verifySAOtpForPassword`, data);
  }
  updatePassword(data:any , id:any) {
    return this.http.put(`${environment.url}/user/${id}`, data);
  }
  getWhiteListIps(query:any) {
    return this.http.get(`${environment.url}/user/getWhiteListIps`, {params:query});
  }
  getWhiteListAccounts(query:any) {
    return this.http.get(`${environment.url}/user/getWhiteListAccounts`, {params:query});
  }

  getCallbackUrls(query:any) {
    return this.http.get(`${environment.url}/user/getCallbackUrls`, {params:query});
  }
  consumer_key(query: any) {
    return this.http.post(`${environment.url}/user/consumer_key?userId=${query.userId}&type=${query.type}&status=${query.status}`, {});
  }
  consumer_secret(query: any) {
    return this.http.post(`${environment.url}/user/consumer_secret?userId=${query.userId}&type=${query.type}&status=${query.status}`, {});
  }
  updateWhiteListIps(id:any, data:any) {
    return this.http.put(`${environment.url}/user/updateWhiteListIps?userId=${id}`, data);
  }
  updateWhiteListAccounts(id:any, data:any) {
    return this.http.put(`${environment.url}/user/updateWhiteListAccounts?userId=${id}`, data);
  }
  updateCallbackListUrls(id:any, data:any) {
    return this.http.put(`${environment.url}/user/updateCallbackListUrls?userId=${id}`, data);
  }
  updateYbAccounts(id:any, data:any) {
    return this.http.put(`${environment.url}/user/updateYbAccounts?userId=${id}`, data);
  }
  updateDmtStatus(id:any, data:any) {
    return this.http.put(`${environment.url}/user/updateDmtStatus?userId=${id}`, data);
  }
  updateAccountStatus(id:any, data:any) {
    return this.http.put(`${environment.url}/user/updateAccountStatus?userId=${id}`, data);
  }
  addWhiteListIps(query: any) {
    return this.http.put(`${environment.url}/user/addWhiteListIps?userId=${query.userId}&ip=${query.ip}`,{});
  }
  addWhiteListAccounts(query: any) {
    return this.http.put(`${environment.url}/user/addWhiteListAccounts?userId=${query.userId}&assignedAccount=${query.assignedAccount}`,{});
  }
  addCallbackListUrls(query: any) {
    return this.http.put(`${environment.url}/user/addCallbackListUrls?userId=${query.userId}&key=${query.key}&value=${query.value}`,{});
  }
  ybAssignAccount(query: any) {
    return this.http.get(`${environment.url}/ybAccount/getList?is_active=${query.is_active}&page=${query.page}&limit=${query.limit}`,{});
  }
  ybAssignAccountById(id: any) {
    return this.http.get(`${environment.url}/ybAccount/getDataById?id=${id}`,{});
  }
  domesticPaymentsForAccountSwap(data: any) {
    return this.http.post(`${environment.url}/payout/domesticPaymentsForAccountSwap`, data);
  }
  yesBankStatement(data: any) {
    return this.http.post(`${environment.url}/payout/inquiry`, data);
  }
  getDataByQuintusIdForAccountSwap(id: any) {
    return this.http.get(`${environment.url}/payout/getDataByQuintusIdForAccountSwap?quintus_transaction_id=${id}`, {});
  }
  updateStatus(query: any) {
    return this.http.put(`${environment.url}/user/updateStatus?id=${query.userId}`,query.frmData);
  }
  // resetPassword(data:any) {
  //   return this.http.post(`${environment.url}/sp/resetPassword`, data);
  // }
}
